<template>
  <div class="stockLayout">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'stockLayout',
  data(){
    return {

    }
  },
  created(){

  },
  mounted(){




  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
.stockLayout{
  position: relative;
  width: 100%;
  height: 100%;
}
</style>